export default __webpack_public_path__ + "static/media/data-analytic.97505d99.jpg";